import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Dietas restrictivas',
    desc: 'Las dietas de bajas calorías solo estresan más a tus glándulas suprarrenales, disparando el cortisol y aumentando la grasa en el vientre.'
  }, {
    title: 'Suplementos genéricos',
    desc: 'Los suplementos genéricos de farmacia no funcionan porque no atacan la resistencia a la insulina que causa los sofocos nocturnos.'
  }, {
    title: "El engaño de 'comer sano'",
    desc: '"Comer sano" según las etiquetas de los supermercados de EE. UU. suele incluir ingredientes químicos que tu hígado no sabe procesar, bloqueando tu balance hormonal natural.'
  }];
  return <SectionWrapper className="bg-brand-surface" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brand-brown mb-12" data-id="element-16">
          Por qué lo que has intentado{' '}
          <span className="text-brand-terracotta" data-id="element-17">no funciona</span>
        </h2>

        <div className="grid gap-6 md:grid-cols-3" data-id="element-18">
          {failures.map((item, index) => <div key={index} className="bg-brand-sand p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-19">
              <XCircleIcon className="w-10 h-10 text-brand-terracotta mb-4" data-id="element-20" />
              <h3 className="font-serif text-xl font-bold text-brand-brown mb-3" data-id="element-21">
                {item.title}
              </h3>
              <p className="font-sans text-brand-brown/80 leading-relaxed" data-id="element-22">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}